import * as React from 'react';
import { t } from '../../../services/HelperService';
import { renderWorkflowCardV2, stripSerializerMetadata } from './workflowCardRuntime';

/**
 * Renders a version-2 workflow card body: evaluates the compiled render script against
 * { queries, card } and injects the sanitized HTML. Script/data failures never break the
 * board — the fallback (title/description) shows with an error chip underneath, and
 * per-query execution errors reported by the server are listed the same way.
 */
export const WorkflowCardV2Renderer = ({ render, queries, card, queryErrors, fallback, style, className }) => {
  const result = React.useMemo(() => renderWorkflowCardV2({ render, queries, card }), [render, queries, card]);
  const serverErrors = Object.entries(stripSerializerMetadata(queryErrors)).filter(([, message]) => !!message);

  return (
    <div className={className} style={style}>
      {result.html
        ? <div dangerouslySetInnerHTML={{ __html: result.html }} />
        : fallback}
      {!!result.error && (
        <div className="wf-card-error">{t('Card script error')}: {result.error}</div>
      )}
      {serverErrors.map(([name, message]) => (
        <div key={name} className="wf-card-error">{t('Card query error')} ({name}): {message}</div>
      ))}
    </div>
  );
};
